import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-渤海银行",
  "use": "icon-渤海银行-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-渤海银行\"><defs><style type=\"text/css\"></style></defs><path d=\"M110.911839 606.146096s397.219144-232.141058 686.105793 134.125944l118.649874-239.879093s-72.221662-147.02267-319.838791-123.808564c-250.196474 23.214106-402.377834 147.02267-484.916876 229.561713z\" fill=\"#00349A\" p-id=\"7370\" /><path d=\"M247.617128 394.639798s92.856423-46.428212 175.395466 0c0 0 224.403023-87.697733 407.536524 2.579346 0 0 72.221662-74.801008-72.221662-105.753149-144.443325-30.952141-239.879093 56.745592-239.879093 56.745592s-131.546599-92.856423-270.831235 46.428211z\" fill=\"#68CA3F\" p-id=\"7371\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/渤海银行.svg
// module id = hOsD
// module chunks = 107